import './index.sass';

export default () => {
  const $root = $('.author-card');

  $root.find('.js-follow').on('ajax:success', function(e) {
    const data = e.detail[0];

    if (data.follow) {
      $(this).removeClass('green')
        .addClass('author-card__follow--remove')
        .text(I18n.t('unsubscribe'))
        .attr('data-method', 'delete')
        .data('method', 'delete')
        .attr('href', data.path)
        .attr('title', I18n.t('unsubscribe'));
    } else {
      $(this).addClass('green')
        .removeClass('author-card__follow--remove')
        .text(I18n.t('subscribe'))
        .attr('data-method', 'post')
        .data('method', 'post')
        .attr('href', data.path)
        .attr('title', I18n.t('subscribe'));
    }
  });
}